import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
    padding: '32px 48px',
    marginTop: '15px',
    marginBottom: '15px',
  },
  textMargin: {
    marginTop: '5px',
  },
}));

export default useStyles;
